import { createFileRoute, redirect, useParams } from "@tanstack/react-router";
import { WorkflowBuilder } from "./-workflow-builder/WorkflowBuilder";
import { useWorkflowBuilderStore } from "@quake/shared-ui/components/automation-ui/store/useWorkflowBuilderStore";
import { useBreadCrumbs } from "~/contexts/useBreadCrumbs";
import { queryClient, trpc } from "~/utils/trpc";
import { hasPermission } from "~/store/usePermissionStore";

export const Route = createFileRoute("/_dashboard/$datasetSlug/automations/new_automation")({
  component: RouteComponent,
  beforeLoad: async ({ params }) => {
    const session = await queryClient.fetchQuery(trpc.auth.getSession.queryOptions()).catch(() => null);

    if (!hasPermission({ role: session?.user?.role, permissions: session?.user?.permissions }, "automations", "view")) {
      throw redirect({ to: "/$datasetSlug/dashboard", params: { datasetSlug: params.datasetSlug } });
    }

    if (
      !hasPermission({ role: session?.user?.role, permissions: session?.user?.permissions }, "automations", "create")
    ) {
      throw redirect({ to: "/$datasetSlug/automations", params: { datasetSlug: params.datasetSlug } });
    }

    useWorkflowBuilderStore.setState({
      nodes: [],
      edges: [],
    });
  },
});

function RouteComponent() {
  const { datasetSlug } = useParams({ from: "/_dashboard/$datasetSlug" });
  useBreadCrumbs([
    { title: "Automations", link: `/${datasetSlug}/automations` },
    { title: "Create", link: `/${location.pathname.split("/")[1]}/automations/new_automation` },
  ]);
  return (
    <div className="-mb-10">
      <WorkflowBuilder />
    </div>
  );
}
